import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import LanguageSwitcher from '../LanguageSwitcher';
import Link from '../Link/Link'
import MenuContext from '../../util/MenuContext';
import _ from 'lodash'

const Footer = ({ language, urls }) => {
  // split into 2 columns
  const { footer: links } = React.useContext(MenuContext)
  const groups = _.chunk(_.union(links, [{ label: "Language", switcher: true }]), 2);

  return (
    <footer className="footer">
      <div className="banner-container">
        <div
          style={{
            height: 20,
            width: 41,
            backgroundColor: '#154273',
            margin: '0 auto',
          }}
        />
      </div>
      <div className="footer-content">
        <div className="content-container wide">
          {groups &&
            groups.map((group, i) => {
              return (
                <div key={uuid()} className="flex">
                  {group.map(column => (
                    <div key={column.label}>
                      <h6>{column.label}</h6>
                      {column.switcher ? (
                        <LanguageSwitcher language={language} urls={urls}  />
                      ) : (
                        <ul>
                          {column.links.map(item => (
                            <li key={item.label}>
                              <Link noStyle href={item.url.path}>{item.label}</Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              );
            })}
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  menus: PropTypes.arrayOf(PropTypes.object),
};

Footer.defaultProps = {
  menus: [
    {
      title: 'DigiD veilig',
      items: [
        {
          name: 'Veiligheid',
          url: '#',
        },
        {
          name: 'Privacy',
          url: '#',
        },
      ],
    },
    {
      title: 'DigiD',
      items: [
        {
          name: 'Wat is DigiD',
          url: '#',
        },
        {
          name: 'Actueel',
          url: '#',
        },
        {
          name: 'Storing en onderhoud',
          url: '#',
        },
        {
          name: 'Contact',
          url: '#',
        },
      ],
    },
    {
      title: 'Disclaimer',
      items: [
        {
          name: 'Cookies',
          url: '#',
        },
        {
          name: 'Privacy',
          url: '#',
        },
      ],
    },
    {
      title: 'Language',
      switcher: true,
    },
  ],
};

export default Footer;
